export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./aggregators.vue?vue&type=template&id=0d646415&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/games/aggregators.vue?vue&type=template&id=0d646415&scoped=true
// module id = lChv
// module chunks = 0